import { render, staticRenderFns } from "./pop-rule.vue?vue&type=template&id=125b6b26"
import script from "./pop-rule.vue?vue&type=script&lang=js"
export * from "./pop-rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports